import React from 'react';
import tag from 'clean-tag';
import styled from 'styled-components';
import { themeGet } from 'styled-system';
import logo from '../images/abf-logo.png';
import { Box, Flex, Container } from '../Layout';

const Header = styled(tag.header)`
  background-color: white;
  padding: 20px 0;
  color: ${themeGet('colors.brand.primary')};
  padding-bottom: ${themeGet('space.14')};

  @media (max-width: ${themeGet('breakpoints.1')}) {
    padding-bottom: ${themeGet('space.8')};
  }
  @media (max-width: ${themeGet('breakpoints.0')}) {
    padding-bottom: ${themeGet('space.4')};
  }
`;

const PageHeading = styled(Box)`
  font-size: 80px;
  @media (max-width: ${themeGet('breakpoints.1')}) {
    font-size: 50px;
  }
  @media (max-width: ${themeGet('breakpoints.0')}) {
    font-size: 20px;
  }
`;

const Applogo = styled(tag.img)`
  height: 120px;
  @media (max-width: ${themeGet('breakpoints.0')}) {
    height: 50px;
  }
`;

const GlobalHeader = () => (
  <Header>
    <Container>
      <Flex alignItems="center">
        <Applogo src={logo} alt="Autsralian Blind Football" />
        <PageHeading ml={8}>Australian Blind Football</PageHeading>
      </Flex>
    </Container>
  </Header>
);

export default GlobalHeader;



// WEBPACK FOOTER //
// ./src/GlobalHeader/GlobalHeader.js